import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

interface UserState {
  token: string | null;
  isLoading: boolean;
  error: string | null;
}

export const initialState: UserState = {
  token: null,
  isLoading: false,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
});

export const hasToken = (state: RootState) => state.user.token;

export default userSlice.reducer;
